(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/top-bar/top-bar-page.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/top-bar/top-bar-page.js');
"use strict";


setGlobal('svs.ticketgames.ticketUtility.components.OverlayPage', _ref => {
  let guide = _ref.guide;
  return React.createElement("div", {
    className: "ts-overlay-content"
  }, React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: svs.content.simple_article.templates.simple_article(guide)
    }
  }));
});

 })(window);